/**
 * Shared ACM / Edge / Ansible content tokens.
 * Surfaces stay role-mapped. Accents use PatternFly semantic tokens so
 * green, blue, red, and warning follow the active light/dark theme.
 */
export interface AcmOverviewTokens {
  bg: string;
  s1: string;
  s2: string;
  s3: string;
  border: string;
  border2: string;
  t1: string;
  t2: string;
  t3: string;
  t4: string;
  red: string;
  redSoft: string;
  warning: string;
  warningSoft: string;
  info: string;
  infoSoft: string;
  success: string;
  successSoft: string;
}

const ACM_STATUS = {
  red: 'var(--pf-t--global--color--status--danger--default)',
  redSoft: 'color-mix(in srgb, var(--pf-t--global--color--status--danger--default) 16%, transparent)',
  warning: 'var(--pf-t--global--color--status--warning--default)',
  warningSoft: 'color-mix(in srgb, var(--pf-t--global--color--status--warning--default) 16%, transparent)',
  info: 'var(--pf-t--global--color--brand--default)',
  infoSoft: 'color-mix(in srgb, var(--pf-t--global--color--brand--default) 16%, transparent)',
  success: 'var(--pf-t--global--color--status--success--default)',
  successSoft: 'color-mix(in srgb, var(--pf-t--global--color--status--success--default) 22%, transparent)',
};

/** Masthead + left nav chrome */
export const ACM_CHROME_BG = '#0a0a0a';

/** Page canvas — mirrors light #f2f2f2 */
export const ACM_DARK_PAGE_BG = '#151515';

/** Card / panel surface — mirrors light #ffffff */
export const ACM_DARK_SURFACE = '#1f1f1f';

export const ACM_DARK_TOKENS: AcmOverviewTokens = {
  bg: '#151515',
  s1: '#1f1f1f',
  s2: '#292929',
  s3: '#3d3d3d',
  border: 'rgba(255,255,255,0.10)',
  border2: 'rgba(255,255,255,0.16)',
  t1: 'var(--pf-t--global--text--color--regular)',
  t2: 'var(--pf-t--global--icon--color--regular)',
  t3: 'var(--pf-t--global--text--color--subtle)',
  t4: 'var(--pf-t--global--text--color--disabled)',
  ...ACM_STATUS,
};

export const ACM_LIGHT_TOKENS: AcmOverviewTokens = {
  bg: '#f2f2f2',
  s1: '#ffffff',
  s2: '#f5f5f5',
  s3: '#e8e8e8',
  border: 'rgba(0,0,0,0.08)',
  border2: 'rgba(0,0,0,0.12)',
  t1: 'var(--pf-t--global--text--color--regular)',
  t2: 'var(--pf-t--global--text--color--subtle)',
  t3: 'var(--pf-t--global--text--color--subtle)',
  t4: 'var(--pf-t--global--text--color--disabled)',
  ...ACM_STATUS,
};
